import React, { useEffect, useState }from 'react';
import { useDispatch, useSelector } from 'react-redux';

import T, { Translate } from '../../i18n/i18n';
import { Logo, Profile, ProfileCard, ProfileColor, ProfileDetails, ProfileName, ProfileEmail, ScrollSpace, ButtonsWrapper, Version } from './ProfileSidebar.styles';
import { ButtonRow, ButtonIcon } from '../../../styles/globalComponents';
import { configActions } from '../../../redux/actions';
import FriendsList from '../FriendsList/FriendsList';
import MessagesList from '../MessagesList/MessagesList';
import ProfileManager from '../ProfileManager/ProfileManager';
import { HEXtoBlackOrWhite } from '../../../services/colors';
import Meta from '../../../meta';
import { useHistory } from 'react-router-dom';

export default () => {
    const [formColor, setFormColor] = useState('');
    const [foreground, setForeground] = useState('#ffffff');

    const username = useSelector(state => state.authState.name);
    const email = useSelector(state => state.authState.email);
    const color = useSelector(state => state.authState.color);

    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        setFormColor(color)
        setForeground(HEXtoBlackOrWhite(color))
    }, [color]);

    const handleViewChangeLog = () => {
        dispatch(configActions.viewChangelog(true));
    }

    const handleGoToHome = () => {
        history.push("/");
    }

    return <Profile>
        <Logo onClick={handleGoToHome}/>
        <ProfileCard>
            <ProfileColor color={formColor || null} foreground={foreground}>{username.substr(0,1)}</ProfileColor>
            <ProfileDetails>
                <ProfileName>{username}</ProfileName>
                <ProfileEmail>{email}</ProfileEmail>
            </ProfileDetails>
        </ProfileCard>
        <ScrollSpace className='scrollbar'>
            <FriendsList />
            <MessagesList />
            <ProfileManager />
        </ScrollSpace>
        <ButtonsWrapper>
            <ButtonRow>
                <Version><T value="version" />{Meta.release} <T value="update" /> {window.appVerion}</Version>
                <ButtonIcon icon="\F02D6" className={'active'} onClick={()=>{window.open('/ajuda', '_blank').focus();}} color="#0c0" title={Translate("gridtools.gotohelp")} />
                <ButtonIcon icon="\F096A" onClick={()=>{handleViewChangeLog()}} color="#f3f" title={Translate("profile.changelog")} />
            </ButtonRow>
        </ButtonsWrapper>
    </Profile>
};